import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox, Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { BankAutocomplete } from '../../../../Components/AutoComplete/AutoComplete';
import { useReactToPrint } from 'react-to-print';

const CustomTextField = styled(TextField)(({ theme }) => ({
    '& .MuiFilledInput-root': {
        backgroundColor: 'transparent',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
    },
    '& .Mui-focused': {
        borderColor: '#673ab7',
    },
    '& .MuiFilledInput-root.Mui-focused': {
        border: '1px solid #673ab7',
    },
}));

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'BankName', label: 'BankName', minWidth: 100 },
    { id: 'AccNo', label: 'Account No', minWidth: 100 },
    { id: 'Ifsc', label: 'Ifsc', minWidth: 100 },
    { id: 'Branch', label: 'Branch', minWidth: 100 },
    { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const BankMaster = () => {
    const [formData, setFormData] = useState({
        BankName: '',
        AccNo: '',
        Ifsc: '',
        Branch: '',
        Remark: ''
    });

    // const permissions = useModulePermissions("Bank Master");

    const [error, setError] = useState({
        bankName: false
    });

    const navigate = useNavigate();

    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const location = useLocation();
    const [currentBankId, setCurrentBankId] = useState(null);
    const [mode, setMode] = useState('view');
    const [lastInsertedBankId, setLastInsertedBankId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [Status, setStatus] = useState("1");
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [banks, setBanks] = useState([]);
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });

    const bankNameRef = useRef(null);
    const AccNoRef = useRef(null);
    const IfscRef = useRef(null);
    const BranchRef = useRef(null);
    const RemarkRef = useRef(null);

    useEffect(() => {
        if (location.state && location.state.BankId) {
            setCurrentBankId(location.state.BankId);
            fetchBankData(location.state.BankId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchBankData = async (id, flag) => {
        try {
            const response = await axios.post(`MstBank/RetriveMstBank`, {
                BankId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const bankData = response.data.Data[0];
                setFormData({
                    // BankName: bankData.BankId.toString(),
                    BankName: bankData.BankName,
                    AccNo: bankData.AccNo,
                    Ifsc: bankData.Ifsc,
                    Branch: bankData.Branch,
                    Remark: bankData.Remark
                });
                setStatus(bankData.Status.toString() || "0");
                setIsFormDisabled(true);
                setCurrentBankId(bankData.BankId);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.error('Failed to fetch bank master data');
            }
        } catch (error) {
            console.error('Error fetching bank master data:', error);
            toast.error('Error fetching bank master data. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
          const params = {
            start: 1,
            PageSize: 1,
            SearchText: ""
          };
      
          try {
            const res = await axios.post('MstBank/getAllMstBankDashBoard', { params });
      
            if (res.data && res.data.Data) {
              setRows(res.data.Data);
              setDataForPrint(res.data.Data);
            } else {
              console.error('No data found in response');
            }
          } catch (err) {
            console.error('Error fetching data:', err);
          }
        };
      
        getRow();
      }, []);

    useEffect(() => {
        const fetchBanks = async () => {
          try {
            const response = await axios.post(`MstBank/getMstBankdrp`);
            if (
              response.data.Status === 0 &&
              response.data.responseStatusCode === 1
            ) {
              setBanks(response.data.Data);
            } else {
              toast.error("Failed to fetch Banks");
            }
          } catch (error) {
            console.error("Error fetching Banks:", error);
            toast.error("Error fetching Banks. Please try again.");
          }
        };
    
        fetchBanks();
      }, []);

    const handlePrevious = async () => {
        if (currentBankId && currentBankId > 1) {
            await fetchBankData(currentBankId, "P");
        }
    };

    const handleNext = async () => {
        if (currentBankId) {
            await fetchBankData(currentBankId, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (name === 'bank') {
            setFormData(prevState => ({
                ...prevState,
                state: ''
            }));
        }

        if (name === 'bank' && value !== '') {
            setTimeout(() => {
                RemarkRef.current.focus();
            }, 100000);
        }
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === bankNameRef.current) {
                AccNoRef.current.focus();
            } else if (event.target === AccNoRef.current) {
                IfscRef.current.focus();
            } else if (event.target === IfscRef.current) {
                BranchRef.current.focus();
            } else if (event.target === BranchRef.current) {
                RemarkRef.current.focus();
            } else {
                RemarkRef.current.focus();
            }
        }
    };

    const handleSave = async () => {

        let hasError = false;

        if (!formData.BankName) {
            toast.error('Bank Name is required');
            setError(prev => ({ ...prev, BankName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, BankName: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                BankName: formData.BankName,
                AccNo: formData.AccNo,
                Ifsc: formData.Ifsc,
                Branch: formData.Branch,
                Remark: formData.Remark,
                Status: Status
            };

            let response;
            if (mode === 'edit') {
                payload.BankId = currentBankId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axios.patch(`MstBank/UpdateMstBank`, payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axios.post(`MstBank/InsertMstBank`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedBankId(response.data.Data)
                    await fetchBankData(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentBankId(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            console.error('Error saving/updating Bank Master:', error);
            toast.error('Error saving/updating Bank Master. Please try again.');
        }
    };

    const handleEdit = async () => {

        let Flag = await checkAndLock(currentBankId, "MstBank", "BankId");
        switch (Flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            BankName: '',
            AccNo: '',
            Ifsc: '',
            Branch: '',
            Remark: ''
        });
        setCurrentBankId(null);

        setTimeout(() => {
            bankNameRef.current.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchBankData(1, "L");
            await UnLock(currentBankId, "MstBank", "BankId");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const resetForm = () => {
        setFormData({
            BankName: '',
            AccNo: '',
            Ifsc: '',
            Branch: '',
            Remark: ''
        });
        setCurrentBankId(null);
        setMode('view');
    };

    const handleExit = () => {
        navigate('/bank-table')
    }

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {

        let Flag = await checkAndLock(currentBankId, "MstBank", "BankId");
        switch (Flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchBankData(currentBankId, "D");
                await fetchBankData(currentBankId, "N");
                setMode('view');
                setIsFormDisabled(true);
                break;
            case 1: toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default: toast.info("Something Went Wrong", { autoClose: 500 });

        }

    };

    return (
        <>

            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>

                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentBankId || currentBankId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                // sx={{ margin: '0px 10px' }}
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentBankId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Bank Master
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="Bank Master"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleConfirmDelete}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} lg={3}>
                                {/* <BankAutocomplete
                                    banks={banks}
                                    value={banks.find(BankName => BankName.Id == formData.BankName) || null}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    error={error.bankName}
                                    helperText={error.bankName ? '' : ''}
                                    ref={bankNameRef}
                                    onKeyDown={handleKeyPress}
                                /> */}
                                <TextField
                                    id="BankName"
                                    name="BankName"
                                    label={
                                        <span>
                                          BankName <span style={{ color: 'red' }}>*</span>
                                        </span>
                                      }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.BankName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={bankNameRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <TextField
                                    id="AccNo"
                                    name="AccNo"
                                    label="Account No"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.AccNo}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={AccNoRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <TextField
                                    id="Ifsc"
                                    name="Ifsc"
                                    label="Ifsc"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Ifsc}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={IfscRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <TextField
                                    id="Branch"
                                    name="Branch"
                                    label="Branch"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Branch}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={BranchRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                    fullWidth
                                    label="Remark"
                                    name="Remark"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    variant="filled"
                                    disabled={isFormDisabled}
                                    className="custom-textfield"
                                    inputRef={RemarkRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>

                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>

                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title="Bank Master"
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />
                }
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default BankMaster
